// Label + required marker + error wrapper around a single control.
export default function Field({
  label,
  required = false,
  htmlFor,
  error,
  help,
  prefix,
  className = "",
  children,
  ...rest
}) {
  return (
    <div className={`peb-field ${error ? "peb-field--error" : ""} ${className}`} {...rest}>
      {label != null && (
        <label className={`peb-field__label ${prefix ? 'd-flex align-items-center' : ''}`} htmlFor={htmlFor}>
          {prefix}
          {label}
          {required && <span className="peb-field__req">*</span>}
          {help}
        </label>
      )}
      {children}
      {error && <div className="peb-field__error" data-testid="field-error">{error}</div>}
    </div>
  );
}
